export class PolizasVencidasNoLiberadasEntity{
    constructor(        
       public   PolCod ?:string,
        public  AseCod ?:number,
        public  NombreAseguradora ?:string,
        public  InicioVigencia ?:string,
        public  FinVigencia ?:string,
        public  RamCod ?:string,
        public  NombreRamo ?:string,
        public  ValorAsegurado ?:number,
        public  UniCod ?:number,
        public  CliCod ?:number,
        public  CiuCod ?:number
    ){

    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/entities/polizas-vencidasnoLiberadas_entity.ts